"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const CopyrightWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'absolute',
    top: '10px',
    right: '10px',
    color: 'white',
    fontSize: '10px',
    fontWeight: 900,
    textShadow: '0px 0px 3px rgba(0,0,0)',
    zIndex: '5',
    '.hero-wrapper &, .slide > .hero-media-wrapper &': {
        bottom: '10px',
        top: 'auto',
    },
    '.lightbox-media-gallery .general-item &': {
        display: 'none',
    },
    '.geo-recommender &': {
        display: ['none', 'inherit'],
    },
    '.lightbox-media-gallery &': {
        position: 'static',
        textAlign: 'right',
        marginBottom: '6px',
    },
}));
const Copyright = ({ children, }) => {
    const [t] = (0, next_i18next_1.useTranslation)(['common']);
    return (react_1.default.createElement(CopyrightWrapper, { className: "copyright" },
        t('copyright.photo'),
        " ",
        children));
};
exports.default = Copyright;
//# sourceMappingURL=Copyright.js.map